(async () => {
    const { Core } = await importModule('Core');

    customElements.define('collection-active-filter', class extends Core {
        render() {
            this.addEventListener('click', this._handleClick.bind(this));
        }

        _handleClick() {
            this.publish('filter:change', {
                url: this.getAttribute('remove-url')
            })

            const $drawer = this.closest('.\\#collection-filters-drawer');
            if ($drawer) $drawer.scrollTo({ top: 0, behavior: 'smooth' });
        }
    })
})();
